export default __webpack_public_path__ + "static/media/KOD0149-min.cd05222d.webp";